import moment from "moment";
import { Promise } from "core-js";
import { route, get, post } from "@utils/network";

export default {
    state: {
        shop: null,
        address: null,
        services: [],
        packages: [],
        shopSearchParams: {
            is_home: 0,
            booking_type: "in-shop",
            datetime: moment().format("MMMM DD, YYYY hh:mm a"),
            latitude: 14.8527252,
            longitude: 120.8160598,
            radius: 5,
        },
        bookingStats: {
            availablePoints: 0,
            violationLimit: 0,
            pointEquivalent: 0,
            unsettledPenalties: 0,
        },
        paymentOptions: [
            { text: "Payment on establishment", value: "cash" },
            // { text: "Paypal Debit/Credit", value: "paypal" },
            // { text: "Paypal later", value: "pay_later" },
            { text: "Pay via GCash", value: "gcash" }
        ],
    },
    
    mutations: {
        SET_SHOP(state, shop) {
            state.shop = shop;
        },
        SET_ADDRESS(state, address) {
            state.address = address;
        },
        SET_PACKAGES(state, packages) {
            state.packages = Array.isArray(packages) && packages.length > 0
                ? [...packages]
                : null;
        },
        SET_SERVICES(state, services) {
            state.services = Array.isArray(services) && services.length > 0
                ? [...services]
                : null;
        },
        SET_SHOP_SEARCH_PARAMS(state, params) {
            state.shopSearchParams = {...params};
        },
        SET_BOOKING_STATS(state, stats) {
            state.bookingStats.availablePoints = parseFloat(stats.availablePoints);
            state.bookingStats.violationLimit = parseFloat(stats.violationLimit);
            state.bookingStats.pointEquivalent = parseFloat(stats.pointEquivalent);
            state.bookingStats.unsettledPenalties = parseFloat(stats.unsettledPenalties);
        },

    },
    actions: {
        setAddress(context, address) {
            context.commit("SET_ADDRESS", address);
        },
        setShop(context, shop) {
            context.commit("SET_SHOP", shop);
        },
        setShopSearchParams(context, params) {
            context.commit("SET_SHOP_SEARCH_PARAMS", params);
        },
        setServicesAndPackages(context, { services, packages }) {
            context.commit("SET_SERVICES", services);
            context.commit("SET_PACKAGES", packages);
        },
        getBookingStats(context) {
            return new Promise((resolve, reject) => {
                get(route("booking-stats"))
                    .then(response => {
                        context.commit("SET_BOOKING_STATS", {
                            availablePoints: parseFloat(response.data.result.availablePoints),
                            violationLimit: parseFloat(response.data.result.violationLimit),
                            pointEquivalent: parseFloat(response.data.result.pointEquivalent),
                            unsettledPenalties: parseFloat(response.data.result.unsettledPenalties),
                        });
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
            
        },

    },
    getters: {
        shop(context) {
            return context.shop;
        },
        address(context) {
            return context.address;
        },
        services(context) {
            return context.services;
        },
        packages(context) {
            return context.packages;
        },
        shopSearchForm(context) {
            return {
                address: context.address,
                form: context.shopSearchParams,
            };
        },
        shopSearchParams(context) {
            return context.shopSearchParams;
        },
        bookingStats(context) {
            return context.bookingStats;
        },
        paymentOptions(context) {
            return context.paymentOptions;
        },
        userToken(context) {
            return localStorage.getItem("auth_token") || null;
        },
    }
};
